var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3214({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 31H11C9.34315 31 8 29.6569 8 28V8C8 6.34315 9.34315 5 11 5H37C38.6569 5 40 6.34315 40 8V23",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 35.5H4C2.34315 35.5 1 34.1569 1 32.5V4C1 2.34315 2.34315 1 4 1H43C44.6569 1 46 2.34315 46 4V23.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7471 46.5H29.1511C28.1231 46.5 27.1666 45.9736 26.6166 45.1052L19.1774 33.359C18.4891 32.2723 18.6464 30.8536 19.556 29.944C20.6296 28.8704 22.3704 28.8704 23.444 29.944L25.7929 32.2929C26.4229 32.9229 27.5 32.4767 27.5 31.5858V17C27.5 15.3431 28.8431 14 30.5 14H31.5C33.1569 14 34.5 15.3431 34.5 17V24.421C34.5 25.6715 35.2757 26.7909 36.4466 27.23L43.8973 30.024C45.3657 30.5747 46.1623 32.1634 45.725 33.6694L42.6281 44.3364C42.256 45.6182 41.0818 46.5 39.7471 46.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 17.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 17.5,
    r: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3214);
export default __webpack_public_path__ + "static/media/Group 3214.b560738ef4d3c5afd47b9a51f4d9d1f5.svg";
export { ForwardRef as ReactComponent };